<template>
  <div>
    <div class="table-header">
      <!-- <el-button type="primary" size="small" @click="handleAdd">添加</el-button>
      <el-button type="primary" size="small" @click="handleHistory">历史记录</el-button> -->
      <div>
        <el-radio-group v-model="tabPosition" style="margin-bottom: 20px" @change="handleTabChange">
          <el-radio-button label="在职">在职</el-radio-button>
          <el-radio-button label="离职">离职</el-radio-button>
        </el-radio-group>
      </div>
    </div>
    <el-table
      :data="tableData"
      style="width: 100%"
      :header-cell-style="headerStyle"
      v-loading="loading"
      :row-class-name="tableRowClassName"
    >
      <el-table-column label="序号" align="center" width="80" type="index"></el-table-column>
      <el-table-column prop="name" label="姓名" align="center" width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.name || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="idCard" label="身份证" align="center" width="180">
        <template slot-scope="scope">
          <span>{{ scope.row.idCard || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="phone" label="电话" align="center" width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.phone || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="area" label="区域园区" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.region || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="personnel_category_hc" label="人员类别" align="center">
        <template slot-scope="scope">
          <span style="color: #219aff">{{ scope.row.personnel_category_hc || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="position" label="计费岗位" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.position || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="position_duties" label="岗位职责" align="center" width="180">
        <template slot-scope="scope">
          <div
            v-if="scope.row.position_duties && scope.row.position_duties.length"
            class="tag-container"
          >
            <el-tag
              v-for="(skill, index) in typeof scope.row.position_duties === 'string'
                ? scope.row.position_duties.split(',')
                : scope.row.position_duties"
              :key="index"
              size="small"
              type="success"
              class="skill-tag"
              >{{ skill }}</el-tag
            >
          </div>
          <div v-else>-</div>
        </template>
      </el-table-column>
      <el-table-column prop="position_nature" label="岗位性质" align="center" width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.position_nature || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.remark || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" align="center" width="80">
        <template slot-scope="scope">
          <span>{{ scope.row.status || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="120">
        <template slot-scope="scope">
          <el-dropdown @command="(command) => handleCommand(command, scope.row)">
            <span class="el-dropdown-link">
              更多操作 <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="edit" :disabled="!canEdit">编辑</el-dropdown-item>
              <el-dropdown-item
                command="delete"
                :disabled="!isAuthorizedUser() || scope.row.status !== '离职' || !canEdit"
                >删除</el-dropdown-item
              >
              <el-dropdown-item command="history">历史记录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageParams.skip"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageParams.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>

    <!-- 编辑抽屉 -->
    <el-drawer
      :title="isEdit ? '编辑计费HC人员' : '添加计费HC人员'"
      :visible.sync="dialogVisible"
      direction="rtl"
      size="30%"
      :before-close="handleClose"
    >
      <div>
        <el-form
          :model="form"
          :rules="rules"
          ref="employeeForm"
          label-width="120px"
          label-position="right"
        >
          <el-form-item label="姓名" prop="name">
            <el-input v-model="form.name"></el-input>
          </el-form-item>
          <el-form-item label="身份证" prop="id_card">
            <el-input v-model="form.id_card"></el-input>
          </el-form-item>
          <el-form-item label="电话" prop="phone">
            <el-input v-model="form.phone"></el-input>
          </el-form-item>
          <el-form-item label="区域园区" prop="region">
            <el-select v-model="form.region" placeholder="请选择" style="width: 100%" @focus="handleSelectFocus">
                  <el-option
                    v-for="(item, index) in campusOptions"
                    :key="index"
                    :label="Object.values(item)[0]"
                    :value="Object.values(item)[0]"
                  ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="人员类别" prop="personnel_category_hc">
            <el-select
              v-model="form.personnel_category_hc"
              placeholder="请选择"
              style="width: 100%"
            >
              <el-option label="计费HC" value="计费HC"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="计费岗位" prop="position">
            <el-select v-model="form.position" placeholder="请选择" style="width: 100%">
              <el-option label="网络运维工程师" value="网络运维工程师"></el-option>
              <el-option label="服务器运维工程师(5*8)" value="服务器运维工程师(5*8)"></el-option>
              <el-option label="IT资产管理员" value="IT资产管理员"></el-option>
              <el-option label="服务器工程师" value="服务器工程师"></el-option>
              <el-option label="网络工程师" value="网络工程师"></el-option>
              <el-option label="资产管理员" value="资产管理员"></el-option>
              <el-option label="C_服务器自维保工程师" value="C_服务器自维保工程师"></el-option>
              <el-option label="C_服务器7*24工程师" value="C_服务器7*24工程师"></el-option>
              <el-option label="C_IT资产管理员" value="C_IT资产管理员"></el-option>
              <el-option label="C_网络运维工程师" value="C_网络运维工程师"></el-option>
              <el-option label="IT运维工程师" value="IT运维工程师"></el-option>
              <el-option label="IT运维岗-初级" value="IT运维岗-初级"></el-option>
              <el-option label="IT运维岗-中级" value="IT运维岗-中级"></el-option>
              <el-option label="IT运维岗-高级" value="IT运维岗-高级"></el-option>
              <el-option label="IT现场运维管理岗" value="IT现场运维管理岗"></el-option>
              <el-option label="综合支持岗" value="综合支持岗"></el-option>
              <el-option label="FRE运营开发岗-初级" value="FRE运营开发岗-初级"></el-option>
              <el-option label="FRE运营开发岗-中级" value="FRE运营开发岗-中级"></el-option>
              <el-option label="FRE运营开发岗-高级" value="FRE运营开发岗-高级"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="岗位职责" prop="position_duties">
            <el-select
              v-model="form.position_duties"
              multiple
              placeholder="请选择"
              style="width: 100%"
            >
              <el-option label="网络" value="网络"></el-option>
              <el-option label="服务器" value="服务器"></el-option>
              <el-option label="资产" value="资产"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="岗位性质" prop="position_nature">
            <el-select v-model="form.position_nature" placeholder="请选择" style="width: 100%">
              <el-option label="5*8小时" value="5*8小时"></el-option>
              <el-option label="7*24小时" value="7*24小时"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="备注" prop="remark">
            <el-input v-model="form.remark" type="textarea" rows="3"></el-input>
          </el-form-item>
          <el-form-item label="状态" prop="status">
            <el-select v-model="form.status" placeholder="请选择" style="width: 100%">
              <el-option label="在职" value="在职"></el-option>
              <el-option label="离职" value="离职"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div style="text-align: right; margin-top: 20px">
          <el-button @click="handleClose">取消</el-button>
          <el-button type="primary" @click="handleSubmit">确定</el-button>
        </div>
      </div>
    </el-drawer>
    <history-dialog :visible.sync="historyDialogVisible" :employee-id="currentEmployeeId" />
  </div>
</template>

<script>
import {
  getEmployeeList,
  createEmployee,
  updateEmployee,
  deleteEmployee,
  getEmployeeDetail,
} from '@/api/employee';
import HistoryDialog from '@/views/platformManage/staff/components/HistoryDialog.vue';
import { getCampusList } from '@/api/operation';
export default {
  name: 'StaffSpecialTable',
  components: {
    HistoryDialog,
  },
  props: {
    headerStyle: {
      type: Object,
      default: () => ({
        background: '#4e71be',
        color: '#fff',
        fontWeight: 'bold',
        textAlign: 'center',
      }),
    },
  },
  data() {
    return {
      loading: false,
      total: 0,
      pageParams: {
        skip: 1,
        limit: 10,
        status: '在职',
        employee_type: '计费HC人员',
      },
      campusOptions: [], // 用于存储园区接口返回的数据
      hasLoaded: false, // 添加标志位防止重复加载
      tableData: [],
      historyDialogVisible: false,
      currentEmployeeId: null,
      dialogVisible: false,
      isEdit: false,
      tabPosition: '在职',
      form: {
        name: '',
        id_card: '',
        phone: '',
        region: '',
        personnel_category_hc: '',
        skill_tags: [],
        status: '在职',
        position_duties: [],
        position_nature: '',
        level: '',
        remark: '',
      },
      rules: {
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        id_card: [
          { required: true, message: '请输入身份证号码', trigger: 'blur' },
          {
            pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
            message: '请输入正确的身份证号码',
            trigger: ['blur', 'change'],
          },
        ],
        phone: [
          { required: true, message: '请输入电话号码', trigger: 'blur' },
          { pattern: /^1\d{10}$/, message: '请输入正确的手机号码', trigger: 'blur' },
        ],
        status: [{ required: true, message: '请选择状态', trigger: 'change' }],
      },
      currentRow: null,
    };
  },
  created() {
    this.getList();
  },
  computed: {
    canEdit() {
      const userId = localStorage.getItem('UserId');
      const userList = JSON.parse(localStorage.getItem('userList') || '[]');
      const currentUser = userList.find((user) => user.name === userId);
      return currentUser && currentUser.editPermission;
    },
  },
  methods: {
    //园区获取数据接口
    async getCampusData() {  
      try {
        const params = {
          spec_sign: 0,
        };
        const response = await getCampusList(params);
        if (response.data && response.data.code === 200) {
          this.campusOptions = response.data.data; 
          this.hasLoaded = true;
          //console.log("成功设置 campusOptions:", this.campusOptions)
        } else {
          console.warn("接口返回状态码不正确:", response.data?.code)
        }
      } catch (error) {
        console.error('获取园区数据失败:', error);
      }
    },
    // focus 事件处理园区获取数据
    handleSelectFocus() {
      if (!this.hasLoaded) {
        this.getCampusData();
      }
    },
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'even-row' : 'odd-row';
    },
    handleAdd() {
      this.isEdit = false;
      this.form = {
        name: '',
        id_card: '',
        phone: '',
        region: [],
        personnel_category_hc: '',
        skill_tags: [],
        status: '在职',
      };
      this.dialogVisible = true;
    },
    isAuthorizedUser() {
      const authorizedUsers = ['韩林达', '周德明', '何文卷', '陈伟锋'];
      const currentUser = localStorage.getItem('UserId') || '';
      return authorizedUsers.includes(currentUser);
    },
    handleCommand(command, row) {
      this.currentEmployeeId = row.id;
      switch (command) {
        case 'edit':
          this.handleEdit(row);
          break;
        case 'delete':
          this.$confirm('确认删除该员工信息吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(async () => {
              try {
                this.form.operator = localStorage.getItem('UserId') || 'admin';
                await deleteEmployee(row.id);
                this.$message.success('删除成功');
                this.getList();
              } catch (error) {
                this.$message.error('删除失败：' + error.message);
              }
            })
            .catch(() => {});
          break;
        case 'history':
          this.historyDialogVisible = true;
          break;
      }
    },
    async handleEdit(row) {
      try {
        this.loading = true;
        const res = await getEmployeeDetail(row.id);
        this.isEdit = true;
        this.currentRow = row;
        const formData = res.data.data.data;
        // 转换日期格式
        if (formData.entry_date) {
          formData.entry_date = formData.entry_date.split('T')[0];
        }
        if (formData.entry_attr_date) {
          formData.entry_attr_date = formData.entry_attr_date?.split('T')[0];
        }
        formData.skill_tags = formData.skill_tags?.length ? formData.skill_tags.split(',') : [];
        formData.position_duties = formData.position_duties?.length
          ? formData.position_duties?.split(',')
          : [];
        this.form = formData;
        this.dialogVisible = true;
      } catch (error) {
        this.$message.error('获取员工详情失败：' + error.message);
      } finally {
        this.loading = false;
      }
    },
    handleHistory() {
      this.historyDialogVisible = true;
    },
    handleTabChange() {
      this.pageParams.status = this.tabPosition;
      this.getList();
    },
    handleClose() {
      this.dialogVisible = false;
      this.$refs.employeeForm.resetFields();
    },
    async handleSubmit() {
      try {
        const valid = await this.$refs.employeeForm.validate();
        if (!valid) {
          return;
        }
        if (this.isEdit) {
          this.form.operator = localStorage.getItem('UserId') || 'admin';
          // 处理skill_tags字段，确保是逗号分隔的字符串
          if (this.form.skill_tags.length && Array.isArray(this.form.skill_tags)) {
            this.form.skill_tags = this.form.skill_tags.join(',');
          } else {
            this.form.skill_tags = '';
          }
          if (this.form.position_duties.length && Array.isArray(this.form.position_duties)) {
            this.form.position_duties = this.form.position_duties.join(',');
          } else {
            this.form.position_duties = '';
          }
          await updateEmployee(this.currentRow.id, this.form);
          this.$message.success('编辑成功');
        } else {
          await createEmployee(this.form);
          this.$message.success('添加成功');
        }
        this.getList();
        this.dialogVisible = false;
        this.$refs.employeeForm.resetFields();
      } catch (error) {
        if (error.message) {
          this.$message.error('操作失败：' + error.message);
        }
      }
    },
    handleSizeChange(val) {
      this.pageParams.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.pageParams.skip = val;
      this.getList();
    },
    async getList() {
      this.loading = true;
      try {
        const res = await getEmployeeList(this.pageParams);
        this.tableData = (res.data.data.list || []).map((item) => ({
          id: item.id,
          name: item.name,
          idCard: item.id_card,
          phone: item.phone,
          region: item.region || '',
          personnel_category_hc: item.personnel_category_hc,
          skill_tags: item.skill_tags || [],
          status: item.status,
          remark: item.remark || '',
          position: item.position || '',
          position_duties: item.position_duties || [],
          position_nature: item.position_nature || '',
        }));
        this.total = res.data.data.total || 0;
      } catch (error) {
        this.$message.error('获取列表失败：' + error.message);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.table-header {
  display: flex;
  justify-content: flex-start;
}

.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}

.pagination-container {
  margin-top: 15px;
  display: flex;
  justify-content: flex-end;
}

.tag-container {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.skill-tag {
  margin: 2px;
}

::v-deep .el-table {
  .even-row {
    background-color: #ced4e8;
  }
  .odd-row {
    background-color: #e9ebf3;
  }
  td.el-table__cell {
    border: 0.5px solid #fff;
  }
}
</style>